import react from 'react'
import { Link } from 'react-router-dom';
import check from './../../../images/check.png'


const Third_Pane = () => (
     <div className="">
          <div className="uk-grid-collapse" data-uk-grid>
               
   



          <div className="uk-width-1-2@s ">
                            <div className="uk-margin-xlarge-left uk-margin-large-top">
                                <h3 className="uk-margin-top uk-margin-remove-left@">Why trust us with your child’s imagination and tech skills</h3>
                            </div>




                     

                            <div className="uk-margin-xlarge-left uk-margin-medium-top">


                            <div className="uk-grid-collapse" data-uk-grid>
                                   <div className="uk-width-1-5">
                                      <img src ={check} className="iconVirt"/>
                                   </div>

                                   <div className="uk-width-4-5">
                                      <p className="textLeft ">Introduce your child to programming and design with
                                       fun game projects and animation challenges</p>
                                   </div>
                            </div>


                             <div className="marginTopSmall">
                            <div className="uk-grid-collapse " data-uk-grid>
                                  
                                   <div className="uk-width-1-5">
                                      <img src ={check} className="iconVirt"/>
                                   </div>

                                   <div className="uk-width-4-5">
                                      <p className="textLeft ">Let your child be part of a smart group of friends
                                       who create together and share their projects </p>
                                
                                   </div>
                            </div>
                            </div>



                               <div className="marginTopSmall">
                            <div className="uk-grid-collapse " data-uk-grid>
                                   <div className="uk-width-1-5">
                                      <img src ={check} className="iconVirt"/>
                                   </div>

                                   <div className="uk-width-4-5 uk-margin-left-remove">
                                      <p className="textLeft ">Boost confidence and problem solving 
                                      abilities help him advance in school and in all aspects of life</p>
                                   </div>
                            </div>
                            </div>



                             <div className="marginTopSmall">
                            <div className="uk-grid-collapse " data-uk-grid>
                                   <div className="uk-width-1-5">
                                      <img src ={check} className="iconVirt"/>
                                   </div>

                                   <div className="uk-width-4-5">
                                      <p className="textLeft ">More than 10 years experience in delivering 
                                       tech-focused camps with top expert teachers to guide your child’s education
                                            </p>
                                   </div>
                            </div>
                            </div>


                            
                            <div className="marginTopSmall">
                            <div className="uk-grid-collapse " data-uk-grid>
                                   <div className="uk-width-1-5">
                                      <img src ={check} className="iconVirt"/>
                                   </div>

                                   <div className="uk-width-4-5">
                                      <p className="textLeft ">Schedule weekly options and choose Virtual 
                                      to take your child’s free time learning at home or anywhere
                                            </p>
                                   </div>
                            </div>
                            </div>

  
                            </div>



                            

                     </div>







               <div className="uk-width-1-2@s  ">
                  <div className="kids_tech">

                  </div>
               </div>
          </div>
     </div>
)



export default Third_Pane


